import styles from './libraryContentRowButtons.module.scss';
import { Chip } from '../../../../../../../../core/components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LibraryContentRowButtons = ({ videoId }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.buttonsContainer}>
            <Chip
                size="small"
                color="primary"
                label={t('CopyLink')}
                clickable
                onClick={() => {
                    navigator.clipboard.writeText(`${window.location.origin}/watch/${videoId}`);
                }}
            />
            <Link to={`/edit/${videoId}`}>
                <Chip size="small" color="secondary" label={t('Edit')} clickable />
            </Link>
        </div>
    );
};

export default LibraryContentRowButtons;
